import React, { useState, useEffect, useCallback } from "react";
import styles from "../Layout.module.css";
import { Link, Navigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import LoginImg from "../../assets/images/login-ico.png";
import DarkLoginImg from "../../assets/images/dark-login-ico.png";
import { useTranslation } from "react-i18next";

function Header() {
  const { t } = useTranslation();

  const [adminName] = useState(() => {
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    return authData ? authData.adminName : "";
  });

  useEffect(() => {
    document.body.classList.add("split");
  }, []);

  const logout = useCallback((e) => {
    sessionStorage.clear();
    window.location.href = "/";
  }, []);

  return (
    <>
      <header
        className={
          window.location.hostname === "dev-tugoadmin.ezzysales.com"
            ? "dev-portal"
            : ""
        }
      >
        <div className="sm-container">
          <div className={styles.headFlx}>
            <Link to={adminName ? "/products" : "/"} className={styles.logo}>
              <img src={Logo} alt="Tugo" />
            </Link>
            <p className={styles.headTxt} style={{ textDecoration: "underline"}}>{t("site_title")}</p>
            <div className={styles.headRight}>
              <div className={styles.rgtFlx}>
                {adminName && (
                  <>
                    <span className={styles.headLog}>
                      <Link to="/changepassword">
                        <i className={`fa fa-key ${styles.ico}`}></i> {t("change_password_txt")}{" "}
                      </Link>{" "}
                      |
                    </span>{" "}
                    <span className={styles.headLog} onClick={(e) => logout(e)}>
                      <i className={`fa fa-sign-out ${styles.ico}`}></i>
                      {t("logout_txt")}
                    </span>{" "}
                  </>
                )}
                {/* {!this.state.adminName && 
                    <Link to="/">
                        <span className={styles.headLog}>
                            Login <img className={styles.nrm} src={LoginImg} alt="Log in" />
                                <img className={styles.hov} src={DarkLoginImg} alt="Log in" />
                             </span>
                    </Link>
                } */}
              </div>
              {/* Login In End */}
              {/* <a href="tel:02195367351" className={styles.headLink}>
                    01295 367 351
                </a> */}
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
export default React.memo(Header);
